/**
 * Prepare les nouveaux elements au centre de la planche.
 * Les tailles suivent les dimensions de la planche.
 * Les textes de depart restent en francais.
 */
import { TGDComponent } from '../../../models/courses/graphicDesign';
import { DEFAULT_FONT_PAIR_ID } from './fonts';

type NewComponent = Omit<TGDComponent, 'id' | 'layer'>;
type Artboard = { width: number; height: number };

const centered = (artboard: Artboard, width: number, height: number): { x: number; y: number } => ({
  x: Math.round((artboard.width - width) / 2),
  y: Math.round((artboard.height - height) / 2),
});

/** Nombres de cotes proposes, zero designant un cercle. */
export const SHAPE_SIDES: number[] = [0, 4, 3, 5, 6];

/** Cree une forme carree centree. */
export const createShapePreset = (sides: number, artboard: Artboard, fill: string): NewComponent => {
  const size = Math.round(Math.min(artboard.width, artboard.height) * 0.25);
  return { type: 'shape', ...centered(artboard, size, size), width: size, height: size,
    rotation: 0, fill, sides, cornerRadius: 0 };
};

/** Cree un pictogramme carre centre. */
export const createPictogramPreset = (icon: string, artboard: Artboard, fill: string): NewComponent => {
  const size = Math.round(Math.min(artboard.width, artboard.height) * 0.25);
  return { type: 'pictogram', ...centered(artboard, size, size), width: size, height: size,
    rotation: 0, fill, icon };
};

/** Cree un texte titre, sous-titre ou corps centre sur la planche. */
export const createTextPreset = (kind: 'title' | 'subtitle' | 'body', artboard: Artboard,
  fill: string, fontPair = DEFAULT_FONT_PAIR_ID, direction: 'ltr' | 'rtl' = 'ltr'): NewComponent => {
  const scale = kind === 'title' ? 0.12 : kind === 'subtitle' ? 0.07 : 0.045;
  const fontSize = Math.round(artboard.width * scale);
  const width = Math.round(artboard.width * 0.8);
  const height = Math.round(fontSize * 1.3);
  const fontWeight = kind === 'title' ? 800 : kind === 'subtitle' ? 600 : 400;
  const text = kind === 'title' ? 'Titre' : kind === 'subtitle' ? 'Sous-titre' : 'Ton texte ici';
  return { type: 'text', ...centered(artboard, width, height), width, height, rotation: 0,
    fill, text, fontSize, fontWeight, fontPair, direction, align: direction === 'rtl' ? 'right' : 'left' };
};
